import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './config/element'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueUeditorWrap from 'vue-ueditor-wrap'

import '@/assets/font/iconfont.css'
import '@/assets/css/app/style.scss'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
installElementPlus(app)
app.use(store).use(router).use(VueUeditorWrap).mount('#app')
